<template>
  <div class="item">
    <div v-if="imagem" class="item__imagem">
      <div
        :style="'background-image: url(' + imagem + ')'"
        class="itemSelecao__imagem"
      ></div>
    </div>
    <div :class="imagem ? 'item__esquerda_imagem' : 'item__esquerda'">
      <p class="texto__principal" :style="customText">{{ textoprincipal }}</p>
      <p class="texto__secundario" :style="customText">{{ textosecundario }}</p>
    </div>
    <div class="item__direita">
      <ChevronRight :size="40" />      
    </div>
  </div>
</template>

<script>
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

export default {
  components: {
    ChevronRight,
  },
  props: ["textoprincipal", "textosecundario", "imagem", "customText", "customIcon"],
};
</script>

<style scoped>
.img-icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.item {
  width: 100%;
  height: 70px;
  padding: 15px 0;
  border-bottom: 1px solid #dbdbdb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item__imagem {
  width: 65px;
  margin-top: 5px;
  display: block;
  justify-content: left;
}
.item__esquerda {
  width: 80%;
  margin-top: 10px;
  display: block;
  justify-content: left;
}
.item__esquerda_imagem {
  width: 70%;
  margin-top: 10px;
  display: block;
  justify-content: left;
}
.item__direita {
  width: 20%;
  margin-top: 10px;
  display: flex;
  justify-content: end;
}
.texto__principal {
  width: 100%;
  text-align: left;
  margin: 0px;
  font-family: "MaisFuturo-Regular", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #7a7a7a;
  letter-spacing: -0.86px;
  cursor: pointer;
}
.texto__secundario {
  width: 100%;
  line-height: 15px;
  text-align: left;
  margin: 0px;
  font-family: "MaisFuturo-Regular", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #7a7a7a;
  letter-spacing: -0.86px;
  cursor: pointer;
}
.material-icons {
  font-size: 30px;
  padding: 3px;
}
.icon-button-minicard {
  color: gray;
}

.itemSelecao__imagem {
  width: 50px;
  height: 50px;
  background-size: contain;
  border-radius: 50px;
}

@media screen and (max-width: 375px) {
  .texto__principal {
    font-size: 12px !important;
  }  
  .texto__secundario {
    font-size: 10px !important;
  }
  .itemSelecao__imagem {
    width: 40px;
    height: 40px;
  }
}
@media (min-width: 376px) and (max-width: 475px) {
  .texto__principal {
    font-size: 16px !important;
  }
  .texto__secundario {
    font-size: 12px !important;
  }
  .itemSelecao__imagem {
    width: 45px;
    height: 45px;
  }
}



</style>
